import { StoryblokStudioFinder } from './StoryblokStudioFinder'

export default StoryblokStudioFinder
